import { Observable, catchError, map, of, shareReplay } from 'rxjs';
import { publishNotificationSession } from './notification-session';

export interface DashboardSessionVerification {
  refresh: () => Observable<unknown>;
  onValidAccess?: () => void;
  clear?: () => void;
}

export function isStoredAccessTokenValid(now = Date.now()): boolean {
  const accessToken = globalThis.sessionStorage?.getItem('accessToken');
  const expiresAt = globalThis.sessionStorage?.getItem('accessTokenExpiresAt');
  const expiresAtTime = expiresAt ? new Date(expiresAt).getTime() : Number.NaN;

  return (
    Boolean(accessToken) && Number.isFinite(expiresAtTime) && expiresAtTime > now
  );
}

export function clearDashboardSessionStorage(): void {
  globalThis.sessionStorage?.removeItem('accessToken');
  globalThis.sessionStorage?.removeItem('accessTokenExpiresAt');
  globalThis.sessionStorage?.removeItem('refreshToken');
  globalThis.sessionStorage?.removeItem('user');
  globalThis.localStorage?.removeItem('refreshToken');
  publishNotificationSession();
}

export function verifyDashboardSession({
  refresh,
  onValidAccess,
  clear = clearDashboardSessionStorage,
}: DashboardSessionVerification): Observable<boolean> {
  if (isStoredAccessTokenValid()) {
    onValidAccess?.();
    return of(true);
  }

  globalThis.sessionStorage?.removeItem('accessToken');
  globalThis.sessionStorage?.removeItem('accessTokenExpiresAt');

  const refreshToken =
    globalThis.localStorage?.getItem('refreshToken') ??
    globalThis.sessionStorage?.getItem('refreshToken');

  if (!refreshToken) {
    clear();
    return of(false);
  }

  return refresh().pipe(
    map(() => true),
    catchError(() => {
      clear();
      return of(false);
    }),
    shareReplay({ bufferSize: 1, refCount: false }),
  );
}
